import React from 'react';
import {PDPProduct} from "../../../model/BonusPointsProduct";

interface AnalyticalConstituentsTabProps {
  product: PDPProduct;
  isMobile: boolean;
}

const AnalyticalConstituentsTab: React.FC<AnalyticalConstituentsTabProps> = (
  {product, isMobile}: AnalyticalConstituentsTabProps) => {
  const GLOBAL_PREFIX= 'loy-bp-pdppd';
  const className = isMobile
    ? `${GLOBAL_PREFIX}_accordion-item-content`
    : `${GLOBAL_PREFIX}_tab-content`;
  return <div className={className}>
    <table className={`${GLOBAL_PREFIX}_analytical-constituents-table`}>
      <tbody>
      {product.analyticalConstituents.map(constituents => {
        return constituents.ingredients.map(ingredient => {
          return <tr key={`${ingredient.name}${ingredient.amount}${ingredient.unit}`}>
            <td>{ingredient.name}</td>
            <td>{ingredient.amount.toFixed(1)} {ingredient.unit}</td>
          </tr>
        })
      })}
      </tbody>
    </table>
  </div>;
};

export default React.memo(AnalyticalConstituentsTab);
